export default __webpack_public_path__ + "static/media/Parallax-HUD-Altitude Range.ad56487d.jpg";